var core = module.exports = {};
if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef


/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-runtime/~/core-js/library/modules/$.core.js
 ** module id = 62
 ** module chunks = 0
 **/